import $ from 'jquery';
import { Interval } from 'utilities/types';

/**
 * Apnea-pattern minute overlay (project_management#555): a translucent band
 * over one screened minute of the sequence that falls in this recording,
 * labelled at the bottom so it does not collide with the noise/AFib labels at
 * the top. Read-only — screening minutes are not annotations.
 */
export const buildApneaInterval = ({ fromX, toX, content, chartHeight, chartWidth }: Interval) => {
  const height = chartHeight ?? 130;
  const maxRight = (chartWidth ?? 1200) - 100;

  const left = Math.max(0, fromX);
  const right = Math.min(maxRight, toX);

  const container = $('<div></div>').css({
    top: 0,
    left,
    width: Math.max(0, right - left),
    height,
    position: 'absolute',
  });

  const ruler = $(`
    <div class="ruler-apnea" data-testid="apnea-band">
        <div class="content"></div>
  </div>`);

  // Text, not HTML: the label is ours, but keep the overlay injection-proof.
  ruler.find('.content').text(content);
  container.append(ruler);
  container.addClass('uplot-additional-element');

  return container;
};
